module.exports = __webpack_public_path__ + "img/img2.b30ab9cd.jpg";